import Vue from 'vue'
import '@/utils/axios'
import 'normalize.css/normalize.css' // A modern alternative to CSS resets

import ElementUI from 'element-ui'
import LqElementUI from 'lq-element-ui-2'
//import 'lq-element-ui/lib/theme-chalk/index.css'
//import locale from 'lq-element-ui/lib/locale/lang/en' // lang i18n

import '../theme/index.css'
import 'vue-phone-number-input/dist/vue-phone-number-input.css';
import '@/styles/index.scss' // global css

import helper from 'vuejs-object-helper'
import App from './App'
import store from './store'
import SvgIcon from 'vue-svgicon'
import Cookies from 'js-cookie'
import moment from 'moment';

import VueCroppie from 'vue-croppie'
import 'croppie/croppie.css' // import the croppie css manually

import VueBlu from 'vue-blu'
// import 'vue-blu/dist/css/vue-blu.min.css'

Vue.use(VueBlu)

Vue.use(VueCroppie)
// import vuexLqForm from 'vuex-lq-form';
// import vuexLqTable from 'vuex-lq-table';
import i18n from './lang' // Internationalization
import { canAccess } from '@/utils';
import { generalConfigs } from '@/api/config';
import lqForm from 'lq-form';
// Vue.use(vuexLqTable, {store});
// Vue.use(vuexLqForm, {store})
import DateRangePicker from 'vue-mj-daterangepicker'
import 'vue-mj-daterangepicker/dist/vue-mj-daterangepicker.css'
Vue.use(DateRangePicker)
import * as VueGoogleMaps from 'vue2-google-maps'
 
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyCb1lKz0gDCSby9QWtaHgp2z6qDzMrmBe4',
    libraries: 'places', // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)
 
    //// If you want to set the version, you can do so:
    // v: '3.26',
  },
})

import '@/components/icons'
// Default tag name is 'svgicon'
Vue.use(SvgIcon, {
  tagName: 'svg-icon',
  defaultWidth: '20px',
  defaultHeight: '20px'
})
import VueI18n from 'vue-i18n'
Vue.use(VueI18n)

Vue.use(ElementUI, {
  size: Cookies.get('size') || 'medium', // set lq-element-ui default size
  i18n: (key, value) => i18n.t(key, value),

})
window.$ = window.jQuery = require('jquery')

/**
 * Application usefull components
 */
import appImage from '@/components/Image';
import Tinymce from '@/components/Tinymce'
import ReadFileStream from '@/components/ReadFileStream'
Vue.component('app-img', appImage);
Vue.component('rich-editor', Tinymce);
Vue.component('read-file-stream', ReadFileStream);

import LqTableActionColumn from '@/components/TableActionColumn';
import { ahpc } from '@/utils';


Vue.component('lq-table-action-column', LqTableActionColumn);

import { getDeviceId, setDeviceId } from '@/utils/auth';
import { guidGenerator } from '@/utils';
Vue.use(lqForm, { store })
Vue.use(LqElementUI, { dataKey: 'data.data', pageSize: 10, storageUrl: 'http://localhost/sghealth/server/public/storage/' })
import '@/components/LqElement'

/**
 * Set the device id in cookie if does not exist.
 */
if (!getDeviceId()) {
  setDeviceId(guidGenerator())
  window.location.reload();
}

/**
 * Set the helper variable
 */
Object.defineProperty(Vue.prototype, '$helper', { value: helper });


generalConfigs()
  .then((response) => {
    store.dispatch('updateAppKey', { key: 'configs', value: response.data.data });
  })
import defaultImageUrl from '@/assets/img/defaultImage.png';
/**
 * Function to make the vue instance.
 */
export default function init(router) {
  new Vue({
    el: '#app',
    router,
    store,
    i18n,
    data: function () {
      return { storage_url: process.env.VUE_APP_STORAGE_URL, defaultImage: defaultImageUrl }
    },
    created() {

      this.$on('submited-error', (response) => {
        // this.$message.error('Your input is not valid. Please check the form.');
      });

      // this.$on('can-not-submit', (from, error) => {
      //   console.log('I am tested', response, error)
      //   this.$message.error('Your input is not valid. Please check the form.');
      // });
      this.$on('has-error', (response) => {

        this.$message.error('The form is already contain some errors.');
      });
    },
    methods: {
      can: function (permission) {
        return canAccess(permission)
      },
      displayDate: function (date, format) {
        format = format ? format : 'DD/MM/YYYY';
        return date ? moment(date).format(format) : '-';
      },
      displayTime: function (date, format) {
        format = format ? format : 'LT';
        return moment(date).format(format);
      },
      ahpc: function (key) {
        return ahpc(key)
      }
    },
    render: h => h(App)
  })
}


/**
 * Remove Does not work on IE , these codes will work to resolve this issue.
 */
if (!('remove' in Element.prototype)) {
  Element.prototype.remove = function () {
    if (this.parentNode) {
      this.parentNode.removeChild(this);
    }
  };
}
Number.prototype.pad = function (size) {
  var s = String(this);
  while (s.length < (size || 2)) { s = "0" + s; }
  return s;
}